var _a;
import { UploadTypes } from 'constants/AdminConstants';
var defaults = (_a = {},
    _a[UploadTypes.UPLOAD_TYPE_LOGO] = '',
    _a[UploadTypes.UPLOAD_TYPE_COVER_PHOTO] = '',
    _a[UploadTypes.UPLOAD_TYPE_USER] = '/img/admin/player_placeholder.png',
    _a[UploadTypes.UPLOAD_TYPE_TEAM] = '/img/admin/team_placeholder.png',
    _a[UploadTypes.UPLOAD_TYPE_GAME] = '',
    _a);
export var getUploadUrl = function (uploadUrl, uploadType) {
    var result;
    if (uploadUrl) {
        result = uploadUrl;
    }
    else if (defaults[uploadType]) {
        result = defaults[uploadType];
    }
    return result;
};
export default {
    getUploadUrl: getUploadUrl
};
